import { useNavigate } from "react-router-dom";

import { IColumnProps } from "../../../interfaces/tables";
import { IBannerListItem } from "../../../interfaces/banners";

import { SVGIcon } from "../../wrappers/SVGIcon";

import { Icons } from "../../../data/Assets";

interface BannersListTableProps {
    banners: IBannerListItem[];
    isLoading: boolean;
};
export const BannersListTable = (props: BannersListTableProps) => {
    const { banners, isLoading } = props;

    const navigate = useNavigate();

    const columns: IColumnProps[] = [
        { name: "Title", identifier: "title" },
        { name: "Description", identifier: "description" },
        { name: "Image", identifier: "image" },
    ];

    const formatValue = (value?: string, maxLength?: number) => {
        if (!value?.length) return '-';
        if (maxLength && value.length > maxLength) return value.substring(0, maxLength) + '...';
        return value;
    };

    return (
        <div className="immersion__list_table__container">
            <table className="immersion__list_table">
                <thead>
                    <tr>
                        {columns.map(column =>
                            <th key={column.identifier}>
                                <div className='display_flex'>
                                    <button className={`${column.buttonClass ?? ''}`}>
                                        {column.name}
                                        {column?.sort && <SVGIcon src={Icons.ArrowDownUp} color='primary' />}
                                    </button>
                                </div>
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {isLoading &&
                        <tr>
                            <td colSpan={columns.length}>
                                <div className="display_flex flex_dir_column display_flex_center">
                                    <span className="wt_600 pb_10">Loading</span>
                                    <i className='immersion__list_loader' />
                                </div>
                            </td>
                        </tr>
                    }
                    {!isLoading && !banners.length &&
                        <tr>
                            <td colSpan={columns.length} className='text_center'>
                                No records found.
                            </td>
                        </tr>
                    }
                    {
                        !isLoading && !!banners.length &&
                        banners.map((item) => {
                            return (
                                <tr
                                    key={item.id}
                                    onClick={() => navigate(`/banners/details/${item.id}`)}
                                >
                                    <td>{formatValue(item.title, 50)}</td>
                                    <td>{formatValue(item.description, 60)}</td>
                                    <td>
                                        {item.image_url
                                            ? <a style={{ display: 'inline', textDecoration: 'underline' }} href={item.image_url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
                                                View Image
                                            </a>
                                            : "-"
                                        }
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};